import { flowRight } from 'lodash/fp';
import { branch, renderNothing, lifecycle } from 'recompose';
import { connect } from 'react-redux';
import { getSimulationSummary, resetSimulationSummary } from '../../actions';

export default flowRight([
    connect(({ simulationSummary }) => ({
        simulationSummary: simulationSummary.simulationSummary,
        errorSimulationSummary: simulationSummary.errorSimulationSummary,
        isLoadingSimulationSummary: simulationSummary.isLoading,
    }), { getSimulationSummary, resetSimulationSummary }),
    lifecycle({
        componentDidMount() {
            this.props.getSimulationSummary(this.props.params.simulationId);
        },

        componentWillUnmount() {
            this.props.resetSimulationSummary();
        },
    }),

    branch(
        ({ isLoadingSimulationSummary }) =>
            isLoadingSimulationSummary,
        renderNothing,
    ),
]);
